"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2442],{

/***/ 92442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2h2c3.4 0 7 3.2 7 8v1c0 2.8-2.2 5-5 5H5c-1.7 0-3-1.3-3-3 0-.8.3-1.6.9-2.1.5-.6 1.3-.9 2.1-.9h8c.5 0 1-.5 1-1v-.1c0-.2-.1-.4-.3-.6-.2-.2-.5-.3-.7-.3h-.1c-.8 0-1.5-.3-2-.9-.6-.6-.9-1.3-.9-2.1 0-1.7 1.3-3 3-3zm4 12c1.7 0 3-1.3 3-3v-1c0-3.5-2.6-6-5-6h-2c-.5 0-1 .4-1 1 0 .3.1.5.2.7.2.2.5.3.7.3h.1c.8 0 1.6.3 2.1.9.6.6.9 1.3.9 2.1 0 1.7-1.4 3-3 3H5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.5 1 1 1h12zm-1.7 5.3c.5-.6 1.3-1.3 2.7-1.3 2 0 3.6 1.9 3.8 2.2.3.4.2 1.1-.2 1.4-.4.3-1.1.2-1.4-.2-.3-.4-1.3-1.4-2.2-1.4-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.4 0-2.2-.7-2.7-1.3-.5-.5-.7-.7-1.3-.7-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-2 0-3.6-1.9-3.8-2.2-.3-.4-.2-1.1.2-1.4.4-.3 1.1-.2 1.4.2C4.1 19 5.1 20 6 20c.6 0 .8-.2 1.3-.7.5-.6 1.3-1.3 2.7-1.3 1.4 0 2.2.7 2.7 1.3.5.5.7.7 1.3.7.6 0 .8-.2 1.3-.7z"
}), "JetSki"));


/***/ })

}]);